(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[31076,99965],{

/***/ 62916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.t = function FaFacebookF (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 320 512"},"child":[{"tag":"path","attr":{"d":"M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"}}]})(props);
};


/***/ }),

/***/ 41084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.D = function FaRegCopy (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"}}]})(props);
};


/***/ }),

/***/ 32631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.u = function FaRegEnvelope (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"}}]})(props);
};


/***/ }),

/***/ 31362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.f = function FaTwitter (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"}}]})(props);
};


/***/ }),

/***/ 874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.x = function FaWhatsapp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}}]})(props);
};


/***/ }),

/***/ 20640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(11742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 31076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Detail_HeaderCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Detail/Icons.js
var Icons = __webpack_require__(80103);
// EXTERNAL MODULE: ./components/FavBtn.js
var FavBtn = __webpack_require__(11614);
// EXTERNAL MODULE: ./components/Fancybox.js
var Fancybox = __webpack_require__(92235);
// EXTERNAL MODULE: ./icons/icons.js
var icons = __webpack_require__(17601);
;// CONCATENATED MODULE: ./components/Detail/Destination.js



var Destination = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className || "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "iconsImgFilter",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Icon */.J, {
                    name: "villaLocation"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "font-bold text-13 lg:text-sm opacity-50 ml-2",
                children: children
            })
        ]
    });
};
/* harmony default export */ var Detail_Destination = (Destination);

// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaWhatsapp.js
var FaWhatsapp = __webpack_require__(874);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaRegEnvelope.js
var FaRegEnvelope = __webpack_require__(32631);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaFacebookF.js
var FaFacebookF = __webpack_require__(62916);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaTwitter.js
var FaTwitter = __webpack_require__(31362);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaRegCopy.js
var FaRegCopy = __webpack_require__(41084);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Detail/HeaderCard.js














var HeaderCard = function(param) {
    var page = param.page;
    var ref = (0,TranslationContext/* useTranslation */.m)(), watchVideo = ref.watchVideo, person = ref.person, bedRoom = ref.bedRoom, bathRoom = ref.bathRoom, shareUpper = ref.shareUpper, shareViaWhatsapp = ref.shareViaWhatsapp, shareViaMail = ref.shareViaMail, shareViaFacebook = ref.shareViaFacebook, shareViaTwitter = ref.shareViaTwitter, copyLink = ref.copyLink, ministryOfTourism = ref.ministryOfTourism, certificateLabel = ref.certificateLabel, certificateNo = ref.certificateNo, applicationNo = ref.applicationNo, applicationInProgress = ref.applicationInProgress;
    var gavelBelgeNo = page.gavelBelgeNo, gavelBasvuruNo = page.gavelBasvuruNo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "px-3 sm:px-[1.3rem] lg:px-0",
        children: [
            page.video ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Fancybox["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    "data-fancybox": "video",
                    "data-src": page.video,
                    className: "bg-white pl-6 pr-5 ml-auto py-4 rounded mb-7 items-center hidden lg:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "mr-2 font-bold text-13 opacity-50 text-brand-black",
                            children: watchVideo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-brand-color-secondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                name: "playbutton"
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-20 pb-1 hidden lg:block"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:bg-white lg:border-[3px] border-detail-border-color rounded flex flex-col lg:px-9 lg:pb-7",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FavBtn/* default */.Z, {
                        className: "ml-auto lg:flex flex-col justify-center items-center -mt-4 hidden w-24",
                        data: {
                            id: page.id,
                            baslik: page.baslik,
                            destination: page.destination,
                            url: page.url,
                            title: page.title,
                            image: page.resim
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex lg:gap-x-12 lg:mt-2 items-center order-last lg:order-none",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "text-brand-black lg:text-xl hidden lg:block font-bold",
                                        children: page.baslik
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Detail_Destination, {
                                        className: "hidden lg:flex md:mt-2 lg:mt-0",
                                        children: page.destination
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "gap-x-3 hidden lg:flex",
                                children: [
                                    page.ribbon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "px-3 py-2 font-bold text-xxs border rounded-sm",
                                        children: page.ribbon
                                    }),
                                    page.ribbon2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "px-3 py-2 font-bold text-xxs border rounded-sm",
                                        children: page.ribbon2
                                    })
                                ]
                            }),
                            gavelBelgeNo || gavelBasvuruNo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-xs border-2 border-[#DC0D15] rounded-md py-2 text-center px-2 mx-auto lg:mr-0 lg:mt-5 mb-2 lg:mb-0 flex lg:flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-16 mx-auto",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                            name: "ktb",
                                            className: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-center justify-center mt-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: ministryOfTourism
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "font-bold",
                                                children: [
                                                    certificateLabel,
                                                    gavelBelgeNo ? certificateNo + gavelBelgeNo : gavelBasvuruNo ? applicationNo + gavelBasvuruNo : applicationInProgress
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-0.5 bg-detail-border-color mt-9 hidden lg:block"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mt-5 lg:mt-7 lg:gap-x-14 justify-between mb-4 lg:mb-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "iconsImgFilter",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                            name: "VillaItemProp1"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col font-bold text-brand-gray-2 ml-3 leading-4 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: page.kisi
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: person
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "iconsImgFilter",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                            name: "VillaItemProp2"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col font-bold text-brand-gray-2 ml-3 leading-4 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: page.yatak_odasi
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: bedRoom
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center justify-items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "iconsImgFilter",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* default */.Z, {
                                            name: "VillaItemProp3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col font-bold text-brand-gray-2 ml-3 leading-4 text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: page.banyo
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: bathRoom
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "font-bold text-13 text-brand-gray items-center ml-auto lg:flex hidden gap-x-3",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-black",
                                        children: shareUpper
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "flex gap-x-3 content-center items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "relative inline-block cursor-pointer group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "whatsapp://send/?text=" + "https://www.balayivillasikirala.com.tr" + "/" + page.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        target: "_blank",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaWhatsapp/* FaWhatsapp */.x, {
                                                                size: 22
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ",
                                                                children: shareViaWhatsapp
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "relative inline-block cursor-pointer group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://www.facebook.com/sharer/sharer.php?u=" + "https://www.balayivillasikirala.com.tr" + "/" + page.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        target: "_blank",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaFacebookF/* FaFacebookF */.t, {
                                                                size: 20
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ",
                                                                children: shareViaFacebook
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "relative inline-block cursor-pointer group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "https://twitter.com/intent/tweet?text=" + "https://www.balayivillasikirala.com.tr" + "/" + page.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        target: "_blank",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaTwitter/* FaTwitter */.f, {
                                                                size: 22
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ",
                                                                children: shareViaTwitter
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "relative inline-block cursor-pointer group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "mailto:?subject=" + page.baslik + "&body=" + "https://www.balayivillasikirala.com.tr" + "/" + page.url,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        target: "_blank",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaRegEnvelope/* FaRegEnvelope */.u, {
                                                                size: 22
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ",
                                                                children: shareViaMail
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "relative inline-block cursor-pointer group",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.CopyToClipboard, {
                                                    text: "https://www.balayivillasikirala.com.tr" + "/" + page.url,
                                                    onCopy: function() {},
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaRegCopy/* FaRegCopy */.D, {
                                                                size: 22
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "group-hover:block hidden absolute bottom-full bg-brand-black text-white rounded-md py-1 left-2 min-w-max px-2 -translate-x-1/2 ",
                                                                children: copyLink
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Detail_HeaderCard = (HeaderCard);


/***/ }),

/***/ 92235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var FancyBox = function(param) {
    var children = param.children, _options = param.options, options = _options === void 0 ? {} : _options, _delegate = param.delegate, delegate = _delegate === void 0 ? "[data-fancybox]" : _delegate;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), scriptsLoaded = ref[0], setScriptsLoaded = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var loadFancybox = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var link;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            // Add CSS
                            if (!document.querySelector('link[href*="fancybox.css"]')) {
                                link = document.createElement("link");
                                link.rel = "stylesheet";
                                link.href = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.css";
                                document.head.appendChild(link);
                            }
                            if (document.querySelector('script[src*="fancybox.umd.js"]')) {
                                _ctx.next = 3;
                                break;
                            }
                            return _ctx.abrupt("return", new Promise(function(resolve) {
                                var script = document.createElement("script");
                                script.src = "https://cdn.jsdelivr.net/npm/@fancyapps/ui@5/dist/fancybox/fancybox.umd.js";
                                script.async = true;
                                script.onload = function() {
                                    return resolve(true);
                                };
                                document.body.appendChild(script);
                            }));
                        case 3:
                            return _ctx.abrupt("return", Promise.resolve(true));
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function loadFancybox() {
                return _ref.apply(this, arguments);
            };
        }();
        loadFancybox().then(function() {
            setScriptsLoaded(true);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (scriptsLoaded && window.Fancybox) {
            // Initialize Fancybox
            window.Fancybox.bind(delegate, options);
            // Cleanup function
            return function() {
                window.Fancybox.destroy();
            };
        }
    }, [
        scriptsLoaded,
        delegate,
        options
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FancyBox);


/***/ }),

/***/ 74300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(20640));

var _excluded = ["text", "onCopy", "options", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  var _super = _createSuper(CopyToClipboard);

  function CopyToClipboard() {
    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, _excluded);

      var elem = _react["default"].Children.only(children);

      return /*#__PURE__*/_react["default"].cloneElement(elem, _objectSpread(_objectSpread({}, props), {}, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 74855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(74300),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 11742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ })

}]);